import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button} from "@material-ui/core";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    containerStyle: {
        display: "flex", 
        alignItems: "center",
        marginTop: 10
    },
    areaStyle: {
        marginRight: 10
    },
    numStyle: {
        backgroundColor: '#dd2c00',
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 5
    }
}));

function DisplayAreas(props) {
    const {t} = useTranslation('complaint');
    const classes = useStyles();

    const complaints = useSelector(state => state.complaintReducer)

    const [value, setValue] = useState('all');
    const [complaintRate, setComplaintRate] = useState('');

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    function handleChooseArea(branchId) {
        props.handleChooseArea(branchId);
    }

    useEffect(() => {
        setValue('All');
    }, [complaints.getAllComplaints])
    useEffect(() => {
        if(props.complaintRate !== undefined) {
            if(props.complaintRate) {
                setComplaintRate(props.complaintRate.toFixed(2));  
            } else {
                setComplaintRate(props.complaintRate);
            }
        }        
    }, [props.complaintRate])

    return (
        <Fragment>
            <Grid className={classes.containerStyle}>
                <div style={{ marginRight: 10, whiteSpace: 'nowrap' }}>{t('area')}</div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <FormControl component="fieldset">
                        <RadioGroup value={value} onChange={handleChange}>
                            <div style={{ display: 'flex', justifyContent: "flex-start", flexWrap: 'wrap' }}>
                                <Button><FormControlLabel value='All' control={<Radio onClick={() => handleChooseArea(-1)}/>} label='All' /><span className={classes.numStyle}>{props.numList[0]}</span></Button>
                                {
                                    props.branches.map((branch) => {
                                        const branchCurr = branch.name.substring(0, branch.name.indexOf(" "))
                                        return (
                                            branch && 
                                            <Button style={{ marginRight: 20 }}>
                                                <FormControlLabel value={branchCurr} control={<Radio onClick={() => handleChooseArea(branch.id)}/>} label={branchCurr} />
                                                <span className={classes.numStyle}>{props.numList[branch.id]}</span>
                                            </Button>
                                        )
                                    })
                                }
                            </div>                       
                        </RadioGroup>
                    </FormControl>
                    <div style={{ padding: 10 }}>{t('area_complaint_rate')}{complaintRate}‰</div>
                </div>                               
            </Grid>           
        </Fragment>
    )
}

export default DisplayAreas;